import React from "react";
import { Check, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const REVIEW_STEPS = [
  { n: 1, key: "evidence", title: "Review your evidence" },
  { n: 2, key: "practice", title: "Confirm practice" },
  { n: 3, key: "signoff", title: "Actions & sign-off" },
];

export function ReviewStepper({ step, onStep, status }) {
  return (
    <nav data-testid="review-stepper" aria-label="Assurance review steps" className="mb-6 rounded-2xl bg-white border border-cream-deep p-2 sm:p-3">
      <ol className="grid grid-cols-3 gap-2">
        {REVIEW_STEPS.map((s) => {
          const current = s.n === step, done = status[s.key]?.done;
          return (
            <li key={s.key}>
              <button type="button" data-testid={`review-step-${s.n}`} onClick={() => onStep(s.n)} aria-current={current ? "step" : undefined}
                className={`w-full text-left rounded-xl px-3 py-2.5 transition-colors ${current ? "bg-brand text-white" : "hover:bg-cream"}`}>
                <span className="flex items-center gap-2">
                  <span className={`h-6 w-6 rounded-full grid place-items-center text-xs font-bold shrink-0 ${current ? "bg-coral text-white" : done ? "bg-rag-green text-white" : "bg-cream-deep text-brand"}`}>{done && !current ? <Check className="h-3.5 w-3.5" /> : s.n}</span>
                  <span className="min-w-0">
                    <span className={`block text-sm font-heading font-bold leading-tight ${current ? "text-white" : "text-brand"} ${current ? "" : "hidden sm:block"}`}>{s.title}</span>
                    {!current && <span className="block sm:hidden text-xs font-semibold text-brand">Step {s.n}</span>}
                    <span className={`block text-[11px] leading-tight ${current ? "text-white/75" : "text-muted-foreground"} hidden md:block`} data-testid={`review-step-${s.n}-status`}>{status[s.key]?.label}</span>
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export function StepNav({ step, onStep, nextLabel }) {
  return (
    <div className="flex items-center gap-3 mt-6 mb-24" data-testid="review-step-nav">
      {step > 1 && (
        <Button variant="outline" data-testid="review-back-btn" onClick={() => onStep(step - 1)} className="rounded-full"><ChevronLeft className="h-4 w-4 mr-1" />Back</Button>
      )}
      {step < 3 && (
        <Button data-testid="review-continue-btn" onClick={() => onStep(step + 1)} className="rounded-full bg-brand hover:bg-brand-hover text-white">{nextLabel || "Continue"}<ChevronRight className="h-4 w-4 ml-1" /></Button>
      )}
    </div>
  );
}
